import { SHARCFlowRun } from 'api/models';

export const SHARC_FLOW_LAST_RUNS: SHARCFlowRun[] = [
  {
    id: 'shrun_248d1982-79dc-484d-8878-a38dd027def6',
    created: 1731512349,
    results: [
      {
        check: {
          created: 0,
          description:
            'Verifies that all ArgoCD deployments are running without unavailable replicas, the specified ArgoCD service is accessible, and ArgoCD applications can be retrieved, ensuring the overall health of ArgoCD resources',
          id: 'resource-health',
          name: 'Check ArgoCD Resource Health for deployments, services, and applications',
          pack: {
            name: 'argocd',
            version: '1.0.0',
          },
          parameters: {
            argo_service: 'argo-cd-argocd-server',
            namespace: 'argocd',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'ArgoCD is installed and verified successfully',
        },
      },
      {
        check: {
          created: 0,
          description:
            'Verifies that the ArgoCD server, controller, and repository components are operational by checking their health endpoints for readiness',
          id: 'api-readiness',
          name: 'Check ArgoCD API Readiness',
          pack: {
            name: 'argocd',
            version: '1.0.0',
          },
          parameters: {
            argo_controller_name: 'argo-cd-argocd-application-controller',
            argo_repo_name: 'argo-cd-argocd-server',
            argo_server_name: 'argo-cd-argocd-server',
            namespace: 'argocd',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'ArgoCD API is ready and verified.',
        },
      },
      {
        check: {
          created: 0,
          description:
            'Validates the full operational capability of ArgoCD by creating and synchronizing a test application, ensuring that application deployment and synchronization processes are functioning correctly within the cluster',
          id: 'end-2-end',
          name: 'Check ArgoCD End-to-End functionality',
          pack: {
            name: 'argocd',
            version: '1.0.0',
          },
          parameters: {
            namespace: 'argocd',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'End to End checks passed successfully for ArgoCD',
        },
      },
    ],
    sharcflow_id: 'shflow_fbb5098c-6194-4c57-9ab6-58f48ddc0ff5',
    status: 'success',
    updated: 1731512386,
  },
  {
    created: 1731513005,
    id: 'shrun_58d58864-76c5-4098-b893-b4e9a7e8c341',
    results: [
      {
        check: {
          created: 0,
          description:
            'Verifies that all ArgoCD deployments are running without unavailable replicas, the specified ArgoCD service is accessible, and ArgoCD applications can be retrieved, ensuring the overall health of ArgoCD resources',
          id: 'resource-health',
          name: 'Check ArgoCD Resource Health for deployments, services, and applications',
          pack: {
            name: 'argocd',
            version: '1.0.0',
          },
          parameters: {
            argo_service: 'argo-cd-argocd-server',
            namespace: 'argocd',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'ArgoCD is installed and verified successfully',
        },
      },
      {
        check: {
          created: 0,
          description:
            'Verifies that the ArgoCD server, controller, and repository components are operational by checking their health endpoints for readiness',
          id: 'api-readiness',
          name: 'Check ArgoCD API Readiness',
          pack: {
            name: 'argocd',
            version: '1.0.0',
          },
          parameters: {
            argo_controller_name: 'argo-cd-argocd-application-controller',
            argo_repo_name: 'argo-cd-argocd-server',
            argo_server_name: 'argo-cd-argocd-server',
            namespace: 'argocd',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'ArgoCD API is ready and verified.',
        },
      },
      {
        check: {
          created: 0,
          description:
            'Validates the full operational capability of ArgoCD by creating and synchronizing a test application, ensuring that application deployment and synchronization processes are functioning correctly within the cluster',
          id: 'end-2-end',
          name: 'Check ArgoCD End-to-End functionality',
          pack: {
            name: 'argocd',
            version: '1.0.0',
          },
          parameters: {
            namespace: 'argocd',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'End to End checks passed successfully for ArgoCD',
        },
      },
    ],
    sharcflow_id: 'shflow_a87cc62c-0fce-408d-b0bf-c7855da071ad',
    status: 'success',
    updated: 1731513038,
  },
  {
    created: 1746138157,
    id: 'shrun_3c2ea2c6-9f97-4a82-8040-5843639199e5',
    results: [
      {
        check: {
          created: 0,
          description:
            'Ensure that the cert-manager deployment is healthy and running by verifying its status',
          id: 'resource-health',
          name: 'Check cert-manager Deployment Health',
          pack: {
            name: 'cert-manager',
            version: '1.0.0',
          },
          parameters: {
            deployment_name: 'cert-manager',
            namespace: 'cert-manager',
            version: '1.14.1',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message:
            'All deployments of cert-manager are healthy and running.',
        },
      },
      {
        check: {
          created: 0,
          description:
            "Ensure that the cert-manager API and webhook are ready and accessible from within the cluster by performing an internal connectivity test to the webhook's health endpoint and verifying API readiness using cert-manager CLI tool",
          id: 'api-readiness',
          name: 'Check cert-manager API Readiness and Internal Connectivity',
          pack: {
            name: 'cert-manager',
            version: '1.0.0',
          },
          parameters: {
            deployment_name: 'cert-manager-webhook',
            namespace: 'cert-manager',
            version: '1.14.1',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'cert-manager API is ready',
        },
      },
      {
        check: {
          created: 0,
          description:
            'Ensure that cert-manager can successfully issue certificates by creating an Issuer and a Certificate resource, then verifying that the certificate is issued and valid within the expected time frame',
          id: 'end-2-end',
          name: 'Check cert-manager Certificate Issuance Functionality',
          pack: {
            name: 'cert-manager',
            version: '1.0.0',
          },
          parameters: {
            version: '1.14.1',
          },
        },
        created: 0,
        status: {
          status: 'success',
          status_message: 'Verified cert-manager functionality ',
        },
      },
    ],
    sharcflow_id: 'shflow_84caff8f-6069-4361-a301-84e29aed9b3c',
    status: 'success',
    updated: 1746138173,
  },
];
